import { render, staticRenderFns } from "./FAQsPage.vue?vue&type=template&id=e490e33a&"
import script from "./FAQsPage.vue?vue&type=script&lang=js&"
export * from "./FAQsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports